import React from "react"

interface CookieSettingsLinkProps {
  onReopen: () => void
  className?: string
}

const CookieSettingsLink = ({
  onReopen,
  className = ``
}: CookieSettingsLinkProps) => (
  <button
    type="button"
    aria-haspopup="dialog"
    onClick={onReopen}
    className={className}
  >
    Cookie Settings
  </button>
)

export default CookieSettingsLink
